<template>
  <div class="product-overview" v-if="getProductData && getStep && getStep"
       :class="{ 'slim' : getStep.id === 'pa_additionals' || getStep.id === 'pa_materac'}">
    <loading v-if="getStep.id !== 'pa_additionals' && getStep.id !== 'pa_materac'"/>
    <div class="product-header">
      <div class="product-desktop">
        <span class="back" @click="closeOrBack">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.7903 20.1129L10.7071 20.2071C10.3466 20.5676 9.77939 20.5953 9.3871 20.2903L9.29289 20.2071L2.29289 13.2071L2.25149 13.1631L2.19633 13.0953L2.12467 12.9841L2.07123 12.8713L2.03584 12.766L2.00691 12.6181L2 12.5L2.00279 12.4248L2.02024 12.2993L2.04974 12.1879L2.09367 12.0768L2.146 11.9793L2.21969 11.8745L2.29289 11.7929L9.29289 4.79289C9.68342 4.40237 10.3166 4.40237 10.7071 4.79289C11.0676 5.15338 11.0953 5.72061 10.7903 6.1129L10.7071 6.20711L5.416 11.5L21 11.5C21.5523 11.5 22 11.9477 22 12.5C22 13.0523 21.5523 13.5 21 13.5L5.414 13.5L10.7071 18.7929C11.0676 19.1534 11.0953 19.7206 10.7903 20.1129L10.7071 20.2071L10.7903 20.1129Z"
                  fill="#3C3C3C"/>
          </svg>
        </span>
        <span class="name">{{ getProductData.name }}</span>
      </div>
      <div class="product-mobile">
        <span class="price">{{ getProductPrice | price }}</span>
        <button type="button" class="next" @click="nextStep" :disabled="!getNextStep">
          <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4L12.585 4L10.2929 1.70711C9.93241 1.34662 9.90468 0.779392 10.2097 0.387101L10.2929 0.292893C10.6534 -0.0675907 11.2206 -0.0953203 11.6129 0.209705L11.7071 0.292893L15.7071 4.29289L15.7485 4.33685L15.8037 4.40469L15.8753 4.51594L15.9288 4.62866L15.9642 4.73401L15.9932 4.88253L16 5L15.9972 5.07524L15.9798 5.20073L15.9503 5.31214L15.9063 5.42322L15.854 5.52071L15.7872 5.61675C15.7623 5.64847 15.7356 5.67864 15.7071 5.70711L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711C9.93241 9.34662 9.90468 8.77939 10.2097 8.3871L10.2929 8.29289L12.585 6L1 6C0.447715 6 0 5.55228 0 5Z" fill="white"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="product-image-wrap">
      <transition enter-active-class="animate__animated animate__fadeIn">
        <img :src="getProductImage" :class="[ getOrientation ]"/>
      </transition>
    </div>
    <div class="product-info">
      <span class="price">{{ getProductPrice | price }}</span>
      <button type="button" class="btn-next" @click="nextStep" :disabled="!getNextStep || getLoading">
        {{ getNextStepName }}
        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11.2097 0.887101L11.2929 0.792893C11.6534 0.432409 12.2206 0.40468 12.6129 0.709705L12.7071 0.792893L19.7071 7.79289L19.7485 7.83685L19.8037 7.90469L19.8753 8.01594L19.9288 8.12866L19.9642 8.23401L19.9931 8.3819L20 8.5L19.9972 8.57524L19.9798 8.70073L19.9503 8.81214L19.9063 8.92322L19.854 9.02071L19.7803 9.12545L19.7071 9.20711L12.7071 16.2071C12.3166 16.5976 11.6834 16.5976 11.2929 16.2071C10.9324 15.8466 10.9047 15.2794 11.2097 14.8871L11.2929 14.7929L16.584 9.5H1C0.447715 9.5 0 9.05229 0 8.5C0 7.94772 0.447715 7.5 1 7.5H16.586L11.2929 2.20711C10.9324 1.84662 10.9047 1.27939 11.2097 0.887101L11.2929 0.792893L11.2097 0.887101Z"
                fill="#C8C8C8"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import axios from "axios";
import Loading from './misc/Loading';
import complementaryDialog from '../../mixins/complementary-dialog'

export default {
  name: "ProductOverview",
  components: {Loading},
  mixins: [complementaryDialog],
  filters: {
    price(price) {
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    }
  },
  computed: {
    ...mapGetters({
      getProduct: 'customizer/getProduct',
      getProductData: 'customizer/getProductData',
      getOptions: 'customizer/getOptions',
      getVariations: 'customizer/getVariations',
      getAttributes: 'customizer/getAttributes',
      getStep: 'customizer/getStep',
      getSteps: 'customizer/getSteps',
      getTotalSteps: 'customizer/getTotalSteps',
      getTotalPrice: 'customizer/getTotalPrice',
      getCustomizerMode: 'customizer/getCustomizerMode',
      getLoading: 'customizer/getLoading'
    }),

    isFirstStep () {
      return this.getSteps.findIndex(step => step.id === this.getStep.id)
    },

    // getProduct2() {
    //   if (!this.getVariations) {
    //     return
    //   }
    //
    //   if (!this.getVariations || !this.getVariations.hasOwnProperty('variations')) {
    //     return
    //   }
    //
    //   let variations = JSON.parse(JSON.stringify(this.getVariations.variations))
    //   let options = JSON.parse(JSON.stringify(this.getOptions))
    //
    //   delete options.group
    //   delete options.pa_additionals
    //
    //   const results = variations.filter((item) => {
    //
    //     // for (let x = 0; x < Object.keys(item.attributes).length; x++) {
    //     //   // console.log(options[Object.keys(item.attributes)[x]], item.attributes[Object.keys(item.attributes)[x]])
    //     //   const key = Object.keys(item.attributes)[x];
    //     //   console.log(options[key], item.attributes[key])
    //     //
    //     //   if (options[key] && options[key] === item.attributes[key] && typeof options[key] === typeof item.attributes[key]) {
    //     //     return true
    //     //   }
    //     // }
    //
    //     for (const v in item.attributes) {
    //       if (!item.attributes[v]) {
    //         return true
    //       }
    //       if (options[v] !== item.attributes[v]) {
    //         return false
    //       }
    //     }
    //     return true;
    //   })
    //
    //   if (!results.length && this.getStep.step > 1) {
    //     return {...this.getVariations.product, default: true}
    //   }
    //
    //   if (results.length > 0) {
    //     return results[0]
    //   }
    //
    //   return this.getVariations.product
    // },
    // getProduct() {
    //   if (!this.getVariations || !this.getSteps) {
    //     return
    //   }
    //
    //   if (!this.getVariations || !this.getVariations.hasOwnProperty('variations')) {
    //     return
    //   }
    //
    //   // const stepIndex = this.getSteps.findIndex(step => step.id === this.getStep.id)
    //   //
    //   // const stepsBefore = stepIndex === 0 ? [this.getSteps[0].id] : this.getSteps.slice(0, stepIndex + 1).map(item => item.id)
    //
    //   let options = JSON.parse(JSON.stringify(this.getOptions))
    //
    //
    //   let values = {}
    //
    //   // stepsBefore.forEach((key, item) => {
    //   //   if (options.hasOwnProperty(key)) {
    //   //     values[key] = options[key]
    //   //   }
    //   // })
    //
    //   delete options.group
    //   delete options.pa_additionals
    //
    //   for (let prop in options) {
    //     if (options[prop] === null || options[prop] === undefined || options[prop].length === 0) {
    //       delete options[prop]
    //     }
    //   }
    //
    //   const results = this.getVariations.variations.filter((item) => {
    //     for (const x in options) {
    //       if (!item.attributes[x]) {
    //         return true
    //       }
    //       if (options[x] !== item.attributes[x]) {
    //         return false
    //       }
    //     }
    //     // for (const v in item.attributes) {
    //     //   // if (!item.attributes[v]) {
    //     //   //   return true
    //     //   // }
    //     //   if ( options[v] !== item.attributes[v]) {
    //     //     return false
    //     //   }
    //     // }
    //     return true;
    //   })
    //
    //
    //   if(this.getStep.step === 1 && !this.getOptions[this.getStep.id]) {
    //     return this.getVariations.product
    //   }
    //
    //   if (!results.length && this.getStep.step > 1) {
    //     return {...this.getVariations.product, default: true}
    //   }
    //
    //   if (results.length) {
    //     return results[0]
    //   }
    //
    //   return this.getVariations.product
    //   // const stepsBefore =
    // },

    getProductPrice() {
      if (!this.getOptions.pa_additionals && this.getProductData) {
        return this.getProductData.price
      }

      if (!this.getProductData || !this.getProductData.price) {
        return
      }

      return parseFloat(this.getProductData.price) + parseFloat(this.getOptions.pa_additionals.reduce((a, b) => a + b.price * b.quantity, 0)) + (this.getOptions.pa_materac ? parseFloat(this.getOptions.pa_materac.price) : 0)
    },
    getProductImage() {
      if (!this.getProductData) {
        return
      }
      return this.getProductData.image
    },
    getNextStep() {
      return this.getStep.completed
    },
    getLastStep() {
      return this.getStep.next === 'pa_additionals'
    },
    getNextStepName() {
      // if (this.getCustomizerMode === 'edit') {
      //   return 'Zastosuj'
      // }
      return this.getStep.next ? this.getSteps.find(step => step.id === this.getStep.next).name : 'Podsumowanie'
    },
    getOrientation() {
      return this.getOptions.pa_uklad === 'lewy' ? 'orientation-left' : 'orientation-right'
    },
    getVariationId () {
      return this.getProduct && this.getProduct.hasOwnProperty('variation') && this.getProduct.variation ? this.getProduct.variation.id : null
    }
  },
  watch: {
    getProduct(n) {
      if (this.getProductData) {
        this.setTotalPrice(this.getProductData.price)
      }
    },
    getOptions: {
      deep: true,
      handler(n) {
        if (this.getStep.id !== 'pa_additionals') {
          this.changeWCVariation()
        }
      }
    },
    getVariationId(n, o) {
      if (!o) {
        return
      }
      if (n !== o) {
        const additionals = this.getOptions.pa_additionals

        if (!additionals.length) {
          return
        }

        if (this.getStep.id !== 'pa_rozmiar_lozka') {
          this.setAdditionals(additionals.filter(product => !product.is_variation))
        }
      }
    }
  },
  mounted() {
    this.setTotalPrice(this.getProductPrice)
  },
  methods: {
    ...mapMutations({
      setPrevStep: 'customizer/setPrevStep',
      setNextStep: 'customizer/setNextStep',
      setStep: 'customizer/setStep',
      setCustomizerOpen: 'customizer/setCustomizerOpen',
      setCustomizerExit: 'customizer/setCustomizerExit',
      setTotalPrice: 'customizer/setTotalPrice',
      setProduct: 'customizer/setProduct',
      setAdditionals: 'customizer/setAdditionals'
    }),
    ...mapActions({
      resetCustomizer: 'customizer/resetCustomizer',
      fetchVariation: 'customizer/fetchVariation'
    }),
    nextStep() {
      if (this.getStep.step === this.getTotalSteps) {
        this.setCustomizerOpen(false)
        this.reinitButton()
      } else {
        this.setNextStep(this.getStep.next)
      }
    },
    reinitButton() {
      const button = document.querySelector('.single_add_to_cart_button')
      button.innerHTML = 'Dodaj do koszyka'
      button.classList.remove('added')
      button.disabled = false
    },
    closeOrBack() {
      if (this.getCustomizerMode === 'edit') {
        this.setCustomizerOpen(false)
        this.setProduct(this.getProduct)
        return
      }
      this.getStep.step > 1 && this.getCustomizerMode === 'create' ? this.setPrevStep(this.getStep.prev) : this.resetCustomizer()
    },
    changeWCVariation() {
      const options = JSON.parse(JSON.stringify(this.getOptions))

      delete options.pa_additionals
      delete options.group

      let form = new FormData()

      Object.keys(options).forEach((item) => {
        if (options[item]) {
          form.append('attribute_' + item, options[item])

          const select = document.querySelector(`select#${item}`)
          if (select) {
            select.value = options[item]
            select.dispatchEvent(new Event("change", {"bubbles": true}))

            if (this.getOptions.pa_uklad === 'lewy') {
              document.querySelector('.product-images .product-image-slider.owl-carousel .owl-item.active img').classList.add('orientation-left')
            } else {
              document.querySelector('.product-images .product-image-slider.owl-carousel .owl-item.active img').classList.remove('orientation-left')
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.product-overview {
  display: flex;
  flex-direction: column;
  padding: 15px 25px 25px 25px;
  border-right: 1px solid #eee;
  flex: 0 0 calc(100% - 390px);
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  overflow: hidden;

  @media (max-width:480px) {
    padding: 15px 0;
    border: none;
  }

  &.slim {
    @media (min-width: 1024px) {
      flex: 0 0 38%;
    }
  }

  @media (max-width: 768px) {
    flex: 0 0 calc(100% - 320px);
  }

  @media (max-width: 680px) {
    flex: 0 0 100%;
  }

  .product-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    position: relative;
    z-index: 1;

    .product-desktop {
      display: flex;
      align-items: center;
      .back {
        width: 48px;
        height: 48px;
        flex: 0 0 48px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #efefef;
        border-radius: 4px;
        transition: all .2s;
        cursor: pointer;

        @media (max-width: 480px) {
          width: 40px;
          height: 40px;
          flex: 0 0 40px;
        }

        &.disabled {
          pointer-events: none;
          svg path {
            fill: #999;
          }
        }

        &:not(.disabled):hover {
          background: #f9f9f9;
        }
      }

      .name {
        margin-left: 15px;
        font-size: 24px;
        font-weight: 600;
        color: #3C3C3C;

        @media (max-width:480px) {
          font-size: 14px;
        }
      }

      @media (max-width:480px) {
        width: 50%;
      }
    }

    .product-mobile {
      align-items: center;
      width: 50%;
      justify-content: flex-end;
      display: none;
      @media (max-width:480px) {
        display: flex;
      }
      .next {
        width: 40px;
        height: 40px;
        flex: 0 0 40px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        transition: all .2s;
        cursor: pointer;
        background: #252525;
        border: none;

        &:disabled {
          background: #EFEFEF;
          svg path {
            fill: #ccc
          }
        }

        &:hover {
          background: #303030;
        }
      }

      .price {
        margin-right: 15px;
        font-size: 14px;
        font-weight: 600;
        color: #252525;
      }
    }
  }

  .product-image-wrap {
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 0;
    overflow: hidden;

    @media (max-width:480px) {
      position: relative;
      transform: none;
      top: 0;
    }

    img {
      max-width: 100%;
      height: auto;

      &.orientation-left {
        -moz-transform: scale(-1, 1);
        -o-transform: scale(-1, 1);
        -webkit-transform: scale(-1, 1);
        transform: scale(-1, 1);
      }
    }
  }

  .product-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    position: relative;
    z-index: 1;

    @media (max-width:480px) {
      display: none;
    }

    .price {
      margin-right: 25px;
      font-size: 24px;
      font-weight: 600;
      color: #3C3C3C;
    }

    .btn-next {
      padding: 12px 32px;
      display: inline-flex;
      align-items: center;
      background: #252525;
      color: #fff;
      border: 0;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      transition: all .2s;

      @media (max-width: 768px) {
        padding: 12px 23px
      }

      svg {
        width: 18px;
        height: auto;
        transition: all .2s;
        margin-left: 10px;

        path {
          fill: #fff;
        }
      }

      &:not(:disabled) {
        cursor: pointer;

        &:hover {
          background: #303030;

          svg {
            transform: translateX(5px);
          }
        }
      }

      &:disabled {
        background: #EFEFEF;
        color: #C8C8C8;

        svg path {
          fill: #C8C8C8;
        }
      }
    }
  }
}
</style>
